import { useLayoutEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import useFetch from "../../hooks/useFetch.js";
import { useDispatch, useSelector } from "react-redux";
import { setHasVcCall } from "../../features/case_details.js";

const VcBar = () => {
  const { role } = useSelector((state) => state.mainFun.user);

  const [token, setToken] = useState(false);
  const [caseName, setCaseName] = useState("");

  const { caseId } = useParams();
  const dispatch = useDispatch();

  const { data } = useFetch({
    url: "vc/user/scheduled/slots/get",
    loading: false,
    body: {},
  });

  useLayoutEffect(() => {
    if (data?.result) {
      if (data.result.vc_cases.length > 0) {
        let token = "";
        let caseName = "";
        let hasVcCall = "";
        data.result.vc_cases.forEach((e) => {
          if (role == "patient") {
            if (e.vc_token && e.case_id == caseId) {
              token = e.vc_token;
              caseName = e.case_name;
            }
          } else {
            if (e.vc_token) {
              hasVcCall = e.case_id;
              token = e.vc_token;
              caseName = e.case_name;
            }
          }
        });
        setToken(token);
        setCaseName(caseName);
        if (hasVcCall) {
          dispatch(setHasVcCall(hasVcCall));
        } else {
          dispatch(setHasVcCall(null));
        }
      } else {
        dispatch(setHasVcCall(null));
      }
    }
  }, [data]);

  return (
    token && (
      <div className="video-call-bar bg-danger">
        <p className="text-center text-white">
          You have an ongoing video call for case{" "}
          <span className="fw-semibold me-2">{caseName}</span>
          <Link
            to={"/vc/" + token}
            className="text-primary text-decoration-underline fw-bold"
          >
            join now
          </Link>
        </p>
      </div>
    )
  );
};

export default VcBar;
